import React from "react";
import Section from "@/components/ui/section";
import Image from "next/image";
export default function WhatWeDo() {
  return (
    <Section variant="flatZero">
      <div className="flex lg:gap-12 gap-6 w-full mx-auto lg:flex-row-reverse flex-col-reverse items-center py-10">
        <div className="flex flex-col gap-3">
          <h2 className="text-darkBlue">Initiatives we Support</h2>
          <p className="">
            PCI invests in initiatives that create lasting impact for those
            often excluded. We have a strong legacy of collaborating with
            grassroots, community-led partners serving disadvantaged
            communities. Our belief is simple: scaling our mission requires
            collaboration across nonprofits, philanthropy, and public-private
            partnerships.
          </p>
        </div>
        <div className="relative lg:w-[400px] lg:h-[400px] md:w-full md:h-[250px] w-full h-[200px] shrink-0 rounded-2xl overflow-hidden">
          <Image
            src="/images/about/What We Do - Who We Are Page.webp"
            alt={"Initiatives we Support"}
            fill
            className="object-cover object-center w-full rounded-2xl"
            sizes="(max-width: 479px) 479px,(max-width: 768px) 768px, (max-width: 1200px) 1200px,(max-width: 1920px) 1920px, 1000px "
          />
        </div>
      </div>
    </Section>
  );
}
